import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';
import { RouteType } from '../../modules/RoutesManagement/types';

export interface SchoolTimingConfig {
  id: string;
  school: string;
  type: RouteType;
  section?: string;
  grade?: string;
  divisions?: string[];
  startTime: string;
  endTime: string;
}

export const getSchoolTimingConfigs = async (
  school: string,
  type: RouteType
): Promise<SchoolTimingConfig[]> => {
  // The app's global axios response interceptor (src/apis/httpClient/axiosInterceptor.ts)
  // already unwraps `.data` for every request, so httpGet resolves with the body directly.
  return httpGet(
    `${envVar.REACT_APP_BUS_TRACKING_API_BASE_URL}/school-timing-configs/school/${school}?type=${type}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_BUS_TRACKING_API_TOKEN}`
      }
    }
  ) as unknown as Promise<SchoolTimingConfig[]>;
};
